import React, { useMemo } from "react";
import HeatPanel from "./HeatPanel";
import { buildHeatGrid, weekdayPlural, weekdayLong } from "./courtStatsMetrics";
import { fmtNumber1, fmtPct0 } from "./statsFormat";

/**
 * Horarios tab: weekday x hour heatmap of the period. Each cell is booked / available court time of
 * that weekday and hour, averaged over the period, so a darker cell is a busier slot. Hours the
 * club is closed (or blocked) are hatched instead of drawn as 0 % (see HeatPanel).
 *
 * @param {{current: object}} props  `current` is a stats response.
 */
export default function HorariosTab({ current }) {
  const grid = useMemo(() => buildHeatGrid(current), [current]);

  const openTip = (row, cell) => {
    const day = cell.days === 1 ? weekdayLong(row.weekday) : weekdayPlural(row.weekday);
    return [
      { value: fmtPct0(cell.value), label: "ocupado" },
      {
        value: `${fmtNumber1(cell.busyCourts)} de ${fmtNumber1(cell.openCourts)}`,
        label: `canchas ocupadas, promedio de ${cell.days} ${day}`,
      },
    ];
  };

  return (
    <HeatPanel
      grid={grid}
      title="Ocupación por día y horario"
      subtitle="Promedio del período. Cuanto más oscura la franja, más pedida."
      ariaLabel="Mapa de ocupación por día de la semana y hora. El detalle está en la vista de tabla."
      closedLabel="Cerrado o bloqueado"
      closedTip="Cerrado o bloqueado"
      openTip={openTip}
    />
  );
}
